<template>
    <div class="calendar-task">
        <div class="calendar-task-tools">
            <div class="calendar-task-tools-left">
                <div>
                    <button style="font-size: 16px" class="btn-calendar" @click="setMonth(calendarTask.month - 1)">
                        «
                    </button>
                    <button style="font-size: 16px" class="btn-calendar" @click="prev()">‹</button>
                </div>
                <span class="calendar-task-date">
                    {{ calendarTask.year }}-{{ (calendarTask.month + 1 + '').padStart(2, '0') }}-{{
                        (calendarTask.day + '').padStart(2, '0')
                    }}
                </span>
                <div>
                    <button style="font-size: 16px" class="btn-calendar" @click="next()">›</button>
                    <button style="font-size: 16px" class="btn-calendar" @click="setMonth(calendarTask.month + 1)">
                        »
                    </button>
                </div>
            </div>
            <div class="calendar-lengend">
                <ul v-if="Working == 'true'">
                    <li type="0">Unhanded</li>
                    <li type="1">Confirmed</li>
                    <li type="-1">Rejected</li>
                </ul>

                <ul v-else>
                    <li type="1">Home Office</li>
                    <li type="2">Business Trip</li>
                    <li type="3">Leave</li>
                </ul>
            </div>
            <div class="calendar-task-tools-right">
                <ul class="calendar-task-type-list">
                    <li @click="changeType('month')" :class="{ active: calendarTask.type == 'month' }">Month</li>
                    <li @click="changeType('week')" :class="{ active: calendarTask.type == 'week' }">Week</li>
                </ul>
                <a href="#/calendar" style="margin-left: 20px;">Change To Time Axis</a>
                <a href="#/workMessageApproval" style="margin-left: 20px;">Approve</a>
                <a href="#/workMessageReport" style="margin-left: 20px;">Report</a>
            </div>
        </div>
        <table v-if="calendarTask.type === 'month'">
            <thead>
                <tr>
                    <th v-for="rowIndex in calendarTask.weeks" :key="rowIndex">
                        {{ rowIndex }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in calendarTask.dataOfMonth" :key="rowIndex">
                    <td
                        :class="{ gray: calendarTask.month != col.month, now: col.now }"
                        v-for="(col, colIndex) in row"
                        :key="colIndex"
                        tabindex="-1"
                    >
                        <div class="calendar-task-cell">
                            <span class="calendar-task-day-num">
                                {{ col.day }}
                            </span>
                            <slot name="default" v-bind="getDayData(col.date)">
                                <ul v-if="Working == 'true'">
                                    <li v-for="(item, index) of getDayData(col.date)" :key="index" class="Working">
                                        <span class="group-header">
                                            {{ item.text }}
                                            <div class="group-header-tool">
                                                <span class="header-tool">
                                                    <a-icon
                                                        style="position: relative; top: 3px; left: 5px"
                                                        type="plus-square"
                                                        @click="operatingClick()"
                                                        theme="twoTone"
                                                    />
                                                </span>
                                            </div>
                                        </span>
                                        <ul v-if="item.children" class="">
                                            <li
                                                v-for="(childItem, childIndex) in item.children"
                                                :key="childIndex"
                                                :type="childItem.type"
                                            >
                                                <!-- <input v-if="UserInfo.IsManager"
                                                    type="checkbox"
                                                    class="group-header-checkbox"
                                                    @change="WorkingApprove(childItem)"
                                                    :checked="childItem.type == '1' ? 'checked' : ''"
                                                /> -->
                                                <span @click="operatingClick(undefined,childItem.id)">
                                                    {{ childItem.name }}
                                                    [<span style="font-size:14px;font-weight:bold; color: red;">{{childItem.Duration}}</span>]
                                                    <a-button v-if="childItem.type == 0" icon="close" type="link" size="small"></a-button>
                                                </span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <ul v-else>
                                    <li v-for="(item, index) of getDayData(col.date)" :key="index">
                                        <span class="group-header">
                                            {{ item.text }}
                                            <div class="group-header-tool">
                                                <slot name="tool" v-bind="item">
                                                    <i
                                                        class="tool"
                                                        v-if="tool && (tool.show === undefined || tool.show())"
                                                        @click="tool.onclick(item)"
                                                    >
                                                        {{ tool.text || '操作' }}
                                                    </i>
                                                </slot>
                                            </div>
                                        </span>
                                        <ul v-if="item.children" class="">
                                            <li
                                                v-for="(childItem, childIndex) in item.children"
                                                :key="childIndex"
                                                :type="childItem.type"
                                            >
                                                <span>{{ childItem.name }}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </slot>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <table v-else-if="calendarTask.type === 'week'">
            <thead>
                <tr>
                    <!-- <th></th> -->
                    <th v-for="(row, rowIndex) in calendarTask.weeks" :key="rowIndex">
                        {{ row }} {{ dateFormat(dateAdd(calendarTask.currentDate, rowIndex - weekSkew), 'MM/dd') }}
                        <span class="header-tool">
                            <a-icon v-if="Working == 'true'"
                                style="position: relative; top: 3px"
                                type="plus-square"
                                @click="operatingClick(dateAdd(calendarTask.currentDate, rowIndex - weekSkew))"
                                theme="twoTone"
                            />
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in calendarTask.dataOfWeek" :key="rowIndex">
                    <td
                        :class="{ gray: calendarTask.month != col.month, now: col.now }"
                        v-for="(col, colIndex) in row"
                        :key="colIndex"
                        tabindex="-1"
                    >
                        <div class="calendar-task-cell">
                            <slot name="default" v-bind="getDayData(col.date)">
                                <ul v-if="Working == 'true'">
                                    <li
                                        @click="itemClick(item)"
                                        class="Working"
                                        v-for="(item, index) of getDayData(col.date)"
                                        :key="index"
                                    >
                                        <span class="group-header">
                                            {{ item.text }}
                                            <div class="group-header-tool">
                                                <slot name="tool" v-bind="item">
                                                    <a-icon
                                                        style="position: relative; top: 3px"
                                                        type="plus-square"
                                                        @click="operatingClick(dateAdd(calendarTask.currentDate, rowIndex - weekSkew))"
                                                        theme="twoTone"
                                                    />
                                                </slot>
                                            </div>
                                        </span>
                                        <ul v-if="item.children" class="">
                                            <li
                                                v-for="(childItem, childIndex) in item.children"
                                                :key="childIndex"
                                                :type="childItem.type"
                                            >
                                                <!-- <input v-if="UserInfo.IsManager"
                                                    type="checkbox"
                                                    class="group-header-checkbox"
                                                    @change="WorkingApprove(childItem)"
                                                    :checked="childItem.type == '1' ? 'checked' : ''"
                                                /> -->
                                                <span @click="operatingClick(undefined,childItem.id)" style="cursor:pointer;">
                                                    {{ childItem.name }}
                                                    [<span style="font-size:14px;font-weight:bold; color: red;">{{childItem.Duration}}</span>]
                                                </span>
                                                <a-popconfirm
                                                    v-if="childItem.type == 0"
                                                    title="确定删除?"
                                                    ok-text="确定"
                                                    cancel-text="取消"
                                                    @confirm="confirmDelete(childItem.id)"
                                                >
                                                    <a-button icon="close" type="link" size="small"></a-button>
                                                </a-popconfirm>
                                                    
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <ul v-else>
                                    <li
                                        @click="itemClick(item)"
                                        v-for="(item, index) of getDayData(col.date)"
                                        :key="index"
                                    >
                                        <span class="group-header">
                                            {{ item.text }}
                                            <div class="group-header-tool">
                                                <slot name="tool" v-bind="item">
                                                    <i
                                                        class="tool"
                                                        v-if="tool && (tool.show === undefined || tool.show())"
                                                        @click="tool.onclick(item)"
                                                    >
                                                        {{ tool.text || '操作' }}
                                                    </i>
                                                </slot>
                                            </div>
                                        </span>
                                        <ul v-if="item.children" class="">
                                            <li
                                                v-for="(childItem, childIndex) in item.children"
                                                :key="childIndex"
                                                :type="childItem.type"
                                            >
                                                <span>{{ childItem.name }}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </slot>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'calendar-task',
    model: {
        prop: 'dataSource',
        event: 'dataChange'
    },
    props: {
        UserInfo:  {
           
        },
        tool: {
            type: Object,
            default: () => ({
                show: () => false,
                text: '工具',
                onclick() {
                    throw new Error('尚未定义');
                }
            })
        },
        Working: false,
        // 日历从周日开始
        suStart: {
            type: Boolean,
            default: true
        },
        date: {
            type: [Date, String],
            default: () => new Date()
        },
        dataSource: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        // 开始的星期偏移量
        weekSkew() {
            return this.suStart ? 1 : 0;
        }
    },

    data: () => ({
        ModalText: 'Modal Text',
        openWorking: false,
        visible: false,
        confirmLoading: false,
        calendarTask: {
            currentDate: new Date(),
            type: '', // month / week
            weeks: ['MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT'],
            year: 0,
            month: 0,
            day: 0,
            dataOfMonth: [],
            dataOfWeek: []
        }
    }),
    created() {
        if (this.suStart) this.calendarTask.weeks.splice(0, 0, 'SUN');
        else this.calendarTask.weeks.push('SUN');
        this.setDate(this.date);
        this.drawCalendar();
        this.changeType('week');
    },
    watch: {
        UserInfo(newVal) {
            this.UserInfo = newVal;
        },
        date(newVal, oldVal) {
            if (this.getDayCount(new Date(newVal)) != this.getDayCount(new Date(oldVal))) {
                this.setDate(new Date(newVal));
            }
        },
        dataSource(newVal, oldVal) {}
    },
    methods: {
        confirmDelete(id) {
            console.log(id);
            this.$emit('delete-item', id);
        },
        itemClick(item) {
            this.$emit('item-click', item);
        },
        prev() {
            if (this.calendarTask.type == 'month') {
                this.setMonth(this.calendarTask.month - 1);
            } else if (this.calendarTask.type == 'week') {
                this.setDate(this.calendarTask.currentDate.getTime() - 7 * 86400000);
            }
        },
        next() {
            if (this.calendarTask.type == 'month') {
                this.setMonth(this.calendarTask.month + 1);
            } else if (this.calendarTask.type == 'week') {
                this.setDate(this.calendarTask.currentDate.getTime() + 7 * 86400000);
            }
        },
        dataChange() {},
        /** 获取当天数据 */
        getDayData(date) {
            const _dayNum = this.getDayCount(date);
            return this.dataSource.filter(i => this.getDayCount(i.date) == _dayNum);
        },
        /** 设置日期 */
        setDate(date) {
            this.calendarTask.currentDate = new Date(date);
            this.calendarTask.year = this.calendarTask.currentDate.getFullYear();
            this.calendarTask.month = this.calendarTask.currentDate.getMonth();
            this.calendarTask.day = this.calendarTask.currentDate.getDate();
            this.drawCalendar();
        },
        /** 设置月份（显示值-1） */
        setMonth(month) {
            this.calendarTask.currentDate = new Date(this.calendarTask.currentDate.setMonth(month));
            this.calendarTask.year = this.calendarTask.currentDate.getFullYear();
            this.calendarTask.month = this.calendarTask.currentDate.getMonth();
            this.calendarTask.day = this.calendarTask.currentDate.getDate();
            this.drawCalendar();
        },
        /** 设置日历展现方式 */
        changeType(type) {
            if (this.calendarTask.type !== type) {
                this.calendarTask.type = type;
                switch (this.calendarTask.type) {
                    case 'month':
                        this.setDate(new Date(new Date().getTime() - (new Date().getDate() - 1) * 86400000));
                        break;
                    case 'week':
                        this.setDate(new Date(new Date().getTime() - (new Date().getDay() - 1) * 86400000));
                        break;
                    default:
                        break;
                }
            }
        },
        drawCalendar() {
            switch (this.calendarTask.type) {
                case 'month':
                    this.getOfMonth();
                    var last = this.calendarTask.dataOfMonth[this.calendarTask.dataOfMonth.length - 1];
                    this.$emit('date-change', {
                        start: this.calendarTask.currentDate,
                        end: last[last.length - 1].date
                    });
                    break;
                case 'week':
                    this.getOfWeek();
                    this.$emit('date-change', {
                        start: this.calendarTask.currentDate,
                        end: new Date(this.calendarTask.currentDate.getTime() + 6 * 86400000)
                    });
                    break;
                default:
                    break;
            }
        },
        // 获取周视图下的总行数
        getOfWeek() {
            let dates = Array(7)
                .fill(null)
                .map((i, index) => {
                    const _date = new Date(
                        this.calendarTask.currentDate.getTime() + (index - this.weekSkew) * 86400000
                    );
                    return {
                        date: _date,
                        month: this.calendarTask.month - 1,
                        now: this.getDayCount(_date) == this.getDayCount(new Date())
                    };
                });
            console.log('aaaaaaaaaaaaaaaa-----------', [dates]);
            this.calendarTask.dataOfWeek = [dates];
        },
        // 获取月视图下的总行数
        getOfMonth() {
            // 一周天数
            let dayCountOfWeek =
                new Date(
                    this.calendarTask.currentDate.getTime() -
                        (this.calendarTask.currentDate.getDate() - 1) * 1000 * 60 * 60 * 24
                ).getDay() + this.weekSkew;
            // 一月天数
            let dayCountOfMonth = this.dayCount(this.calendarTask.currentDate);
            // 月视图总行数
            let rowCount = Math.ceil((dayCountOfWeek + dayCountOfMonth - 1) / 7);
            let dayCountOfPrevMonth = this.dayCount(
                new Date(new Date(this.calendarTask.currentDate).setMonth(this.calendarTask.month - 1))
            );

            let dates = [];
            for (let index = 0; index < dayCountOfWeek - 1; index++) {
                dates.push({
                    date: new Date(
                        `${
                            this.calendarTask.month - 1 <= -1
                                ? this.calendarTask.currentDate.getFullYear() - 1
                                : this.calendarTask.currentDate.getFullYear()
                        }-${this.calendarTask.month}-${
                            dayCountOfPrevMonth - dayCountOfWeek + 1 + index + this.weekSkew
                        }`
                    ),
                    month: this.calendarTask.month - 1,
                    day: dayCountOfPrevMonth - dayCountOfWeek + 1 + index + this.weekSkew,
                    now: false
                });
            }
            for (let index = 0; index < dayCountOfMonth; index++) {
                dates.push({
                    date: new Date(`${this.calendarTask.year}-${this.calendarTask.month + 1}-${index + 1}`),
                    month: this.calendarTask.month,
                    day: index + 1,
                    now:
                        this.getDayCount(`${this.calendarTask.year}-${this.calendarTask.month + 1}-${index + 1}`) ==
                        this.getDayCount(new Date())
                });
            }
            if ((dayCountOfWeek + dayCountOfMonth - 1) % 7 > 0) {
                for (let index = 0; index < 7 - ((dayCountOfWeek + dayCountOfMonth - 1) % 7); index++) {
                    dates.push({
                        date: new Date(
                            `${
                                this.calendarTask.month + 2 > 12 ? this.calendarTask.year + 1 : this.calendarTask.year
                            }-${this.calendarTask.month + 2 > 12 ? 1 : this.calendarTask.month + 2}-${index + 1}`
                        ),
                        month: this.calendarTask.month + 1,
                        day: index + 1,
                        now: false
                    });
                }
            }

            this.calendarTask.dataOfMonth = Array(rowCount)
                .fill(null)
                .map((i, index) => {
                    return dates.slice(index * 7, (index + 1) * 7);
                });
        },
        /// 获取一个月多少天
        dayCount(date) {
            const yearNum = date.getFullYear();
            const monthNum = date.getMonth() + 1;
            let dayNum = 0;
            if (monthNum != 2) {
                //判断是否是相同天数的几个月，二月除外
                if (monthNum == 4 || monthNum == 6 || monthNum == 9 || monthNum == 11) dayNum = 30;
                else dayNum = 31;
            } else {
                //判断是否是闰年，进行相应的改变
                if ((yearNum % 4 == 0 && yearNum % 100 != 0) || yearNum % 400 == 0) dayNum = 29;
                else dayNum = 28;
            }
            return dayNum;
        },
        /** 日期格式化 */
        dateFormat(date, fmt = 'yyyy-MM-dd') {
            if (!date) return '';
            if (typeof date === 'string') {
                date = new Date(date.replace(/-/g, '/'));
            }
            const o = {
                'M+': date.getMonth() + 1, //月份
                'd+': date.getDate(), //日
                'H+': date.getHours(), //小时
                'm+': date.getMinutes(), //分
                's+': date.getSeconds(), //秒
                'q+': Math.floor((date.getMonth() + 3) / 3), //季度
                S: date.getMilliseconds() //毫秒
            };
            let _fmt = fmt;
            if (/(y+)/.test(fmt))
                _fmt = _fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            for (const k in o)
                if (new RegExp('(' + k + ')').test(_fmt))
                    _fmt = _fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
                    );
            return _fmt;
        },
        dateAdd(date, addDay) {
            return new Date(new Date(date).setDate(new Date(date).getDate() + addDay));
        },
        /** 日期天数 */
        getDayCount(date) {
            const _date = new Date(date).getTime() + 3600000 * 8;
            return _date - (_date % (3600000 * 24)) - 3600000 * 8;
        },
        //打开工时操作页面
        //点击操作方法
        operatingClick(date,item) {
            console.log(item)
            this.$emit('operating-click', date,item);
        },
        WorkingApprove(item) {
            if (event.target.checked) {
                //修改数据前面的颜色标识
                item.type = '1';
            } else {
                item.type = '0';
            }
            this.$emit('WorkingApprove-change', item.id);
        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.visible = false;
        },
        handleCancel() {
            this.visible = false;
        }
    }
};
</script>
<style scoped>
.group-header-tool {
    display: none;
}
.Working:hover .group-header-tool {
    display: block;
}
.header-tool {
    float: right;
    font-weight: normal;
    line-height: 16px;
    padding-right: 10px;
}
.group-header-checkbox {
    position: relative;
    top: 2px;
}

.ant-col-4 {
    width: auto !important;
}
</style>

<style scoped lang="scss">
.calendar-task {
    width: 100%;
    margin: auto;

    button.btn-calendar {
        cursor: pointer;
        display: inline-block;
        line-height: 30px;
        border: 1px solid #d9d9d9;
        color: rgba(0, 0, 0, 0.65);
        padding: 0px 12px;
        border-radius: 4px;
        font-size: 14px;
        transition: 0.3s;
        background: white;
        margin: 0px 6px;
        outline: none;

        &:hover {
            color: #1890ff;
        }

        &.active {
            color: #1890ff;
            background: #fff;
            border-color: #1890ff;
        }
    }

    > .calendar-task-tools {
        user-select: none;
        display: flex;
        justify-content: space-between;
        padding: 15px 10px;
        box-sizing: border-box;

        > .calendar-task-tools-left {
            display: flex;

            > .calendar-task-date {
                display: inline-block;
                line-height: 32px;
                padding: 0px 10px;
                font-size: 14px;
            }
        }

        > .calendar-lengend {
            display: flex;
            ul {
                padding-left: 4px;
                padding-right: 4px;
                margin: 0px;
                border-radius: 4px;
                margin-top: 6px;
                margin-bottom: 4px;

                li {
                    box-sizing: border-box;
                    list-style: none;
                    border-radius: 3px;
                    text-align: left;
                    font-size: 12px;
                    color: #666666;
                    vertical-align: middle;
                    display: inline-block;
                    margin-right: 10px;

                    &:before {
                        content: '';
                        display: inline-block;
                        width: 9px;
                        height: 9px;
                        background-color: #faad14;
                        border-radius: 50%;
                        margin-right: 6px;
                        vertical-align: middle;
                    }
                }
            }
        }

        > .calendar-task-tools-right {
            > .calendar-task-type-list {
                display: inline-block;
                padding-left: 0px;
                margin: 0px;

                > li {
                    cursor: pointer;
                    display: inline-block;
                    line-height: 30px;
                    color: rgba(0, 0, 0, 0.65);
                    border: 1px solid #d9d9d9;
                    padding: 0px 12px;
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    font-size: 14px;
                    transition: 0.3s;
                    outline: none;

                    &:hover {
                        color: #1890ff;
                    }

                    &.active {
                        color: #1890ff;
                        background: #fff;
                        border-color: #1890ff;

                        + li {
                            border-left-color: #1890ff;
                        }
                    }

                    &:first-child {
                        border-right: none;
                        border-top-left-radius: 4px;
                        border-bottom-left-radius: 4px;
                        border-top-right-radius: 0px;
                        border-bottom-right-radius: 0px;
                    }
                }
            }
        }
    }

    > table {
        width: 100%;
        border-spacing: 8px 0px;
        border-collapse: separate;

        > thead {
            > tr {
                > th {
                    text-align: center;
                    font-weight: normal;
                    font-size: 13px;
                    line-height: 20px;
                    color: #595959;
                    white-space: nowrap;
                    width: 14.3%;
                }
            }
        }

        > tbody {
            > tr {
                > td {
                    position: relative;
                    user-select: none;
                    text-align: center;
                    border-top: 2px solid #e8e8e8;
                    padding-bottom: 4px;
                    transition: 0.15s;
                    outline: none;
                    transition: 0.3s;
                    vertical-align: top;

                    &.gray {
                        > .calendar-task-cell {
                            > .calendar-task-day-num {
                                color: rgba(0, 0, 0, 0.25);
                            }
                        }
                    }
                    &.now {
                        border-top: 2px solid #349eff;
                    }
                    &:hover {
                        background: #e6f7ff;
                    }
                    &:active {
                        background: #bae7ff;
                    }
                    &:focus {
                        background: #e6f7ff;
                        border-top: 2px solid #349eff;

                        > .calendar-task-cell {
                            > .calendar-task-day-num {
                                color: #349eff;
                                background-color: #c5e5ec;
                            }
                        }
                    }

                    > .calendar-task-cell {
                        min-height: 100px;
                        // position: absolute;
                        // top: 0px;
                        // left: 0px;
                        // width: 100%;
                        // height: 100%;

                        > .calendar-task-day-num {
                            user-select: none;
                            display: block;
                            width: 100%;
                            text-align: right;
                            font-size: 14px;
                            line-height: 22px;
                            padding-right: 6px;
                            box-sizing: border-box;
                            color: rgba(0, 0, 0, 0.65);
                            background-color: #e0eff7;

                            + ul {
                                margin-top: 0px;
                            }
                        }

                        ul {
                            padding-left: 4px;
                            padding-right: 4px;
                            margin: 0px;
                            border-radius: 4px;
                            margin-top: 6px;
                            margin-bottom: 4px;

                            li {
                                width: 100%;
                                box-sizing: border-box;
                                list-style: none;
                                border-radius: 3px;
                                text-align: left;
                                font-size: 12px;
                                color: #666666;
                                vertical-align: middle;
                                margin-bottom: 8px;

                                > .group-header {
                                    display: inline;
                                    vertical-align: middle;

                                    > .group-header-tool {
                                        float: right;
                                        font-weight: normal;
                                        line-height: 16px;

                                        > .tool {
                                            cursor: pointer;
                                            color: #1890ff;
                                            font-size: 12px;
                                            font-style: normal;
                                        }
                                    }
                                }

                                &:before {
                                    content: '';
                                    display: inline-block;
                                    width: 9px;
                                    height: 9px;
                                    background-color: #faad14;
                                    border-radius: 50%;
                                    margin-right: 6px;
                                    vertical-align: middle;
                                }

                                + li {
                                    margin-top: 5px;
                                }
                            }
                        }

                        > ul {
                            background-color: transparent;

                            > li {
                                border: 1px solid #e8e8e8;
                                background-color: white;

                                + li {
                                    margin-top: 4px;
                                }

                                > .group-header {
                                    display: inline-block;
                                    width: 100%;
                                    box-sizing: border-box;
                                    padding: 3px 5px;
                                    border-bottom: 1px dashed #e8e8e8;
                                    font-weight: bold;
                                    font-size: 13px;
                                }

                                &:before {
                                    content: none;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
